import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  const filterState = localStorage.getItem('openedFilter')
  if (filterState === 'true') {
    $('.hidden-filter-set-link').text('Weniger anzeigen')
    $('.hidden-filter-set').show()
  }
  $('.hidden-filter-set-link').click(function () {
    $(this).text((_, value) => (value === 'Weniger anzeigen' ? 'Mehr anzeigen' : 'Weniger anzeigen'))
    if ($('.hidden-filter-set').css('display') === 'none') {
      $('.hidden-filter-set').css('display', 'block')
      localStorage.setItem('openedFilter', true)
    } else {
      $('.hidden-filter-set').css('display', 'none')
      localStorage.setItem('openedFilter', false)
    }
  })
})
